// // app/components/utils/historyUtils.js

// export const TRACK_KEYS = [
//   "date",
//   "counselor_name",
//   "counselor_title",
//   "school",
//   "email",
//   "phone",
//   "address1",
//   "address2",
//   "student",
//   "college",
//   "program",
//   "relationship",
//   "time_known",
//   "mission",
//   "values",
//   "alignment",
//   "achievements",
//   "hard_skills",
//   "soft_skills",
//   "reasons",
//   "story",
//   "closing",
//   "signature",
//   "recipient_name",
//   "recipient_title",
//   "recipient_org",
//   "recipient_addr1",
//   "recipient_addr2",
//   "recipient_salutation",
//   "need_reason",
//   "ai_experience_prompt",
//   "header_line1",
//   "header_line2",
//   "header_addr1",
//   "header_addr2",
//   "header_greeting",
//   "sport",
// ];

// export const storageKey = (k) => `cb_hist_${k}`;

// export const pushToHistoryArray = (arr, val, limit = 10) => {
//   const v = String(val || "").trim();
//   if (!v) return arr;
//   const set = new Set(arr);
//   set.delete(v);
//   const next = [v, ...set];
//   return next.slice(0, limit);
// };

// // app/components/ui/HistoryDatalist.jsx
// import { uniqKeepOrder } from '../utils/stringUtils';

// export const HistoryDatalist = ({ id, values, extras = [] }) => {
//   const combined = uniqKeepOrder([...(values || []), ...extras]);
//   return (
//     <datalist id={id}>
//       {combined.map((v) => (
//         <option key={`${id}-${v}`} value={v} />
//       ))}
//     </datalist>
//   );
// };

// app/components/utils/historyUtils.js

// Keys whose input values you want to keep a short rolling history for
export const TRACK_KEYS = [
  // meta / header
  "date",
  "counselor_name",
  "counselor_title",
  "school",
  "email",
  "phone",
  "address1",
  "address2",

  // recipient (optional)
  "recipient_name",
  "recipient_title",
  "recipient_org",
  "recipient_addr1",
  "recipient_addr2",
  "recipient_salutation",

  // student / target
  "student",
  "college",
  "program",
  "sport",

  // context
  "relationship",
  "time_known",
  "mission",
  "values",
  "alignment",
  "meeting_notes",

  // evidence sections
  "achievements",
  "hard_skills",
  "soft_skills",
  "reasons",
  "story",
  "experience",            // ← needed by ExperienceSection pushHistory
  "need_reason",

  // AI helpers
  "ai_experience_prompt",

  // header lines (optional letterhead)
  "header_line1",
  "header_line2",
  "header_addr1",
  "header_addr2",
  "header_greeting",

  // closing/signature
  "closing",
  "signature",
];

export const storageKey = (k) => `cb_hist_${k}`;

/**
 * Push a value into a history array with:
 * - trimming
 * - case-insensitive de-duplication (newest first)
 * - max length (default 10)
 */
export const pushToHistoryArray = (arr, val, limit = 10) => {
  const list = Array.isArray(arr) ? arr : [];
  const v = String(val ?? "").trim();
  if (!v) return list;

  const lower = v.toLowerCase();
  const seen = new Set([lower]);
  const out = [v];

  for (const item of list) {
    const s = String(item ?? "").trim();
    if (!s) continue;
    const l = s.toLowerCase();
    if (seen.has(l)) continue;
    out.push(s);
    seen.add(l);
    if (out.length >= limit) break;
  }

  return out.slice(0, limit);
};
